import TableViewIcon from "@mui/icons-material/TableView";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { GridApiPro } from "@mui/x-data-grid-pro";
import { MutableRefObject } from "react";
import { useTranslation } from "react-i18next";
import { exportGridAsExcel } from "@/components/grid/CustomToolbar/GridExcelExportMenuItem";

interface Props {
  apiRef: MutableRefObject<GridApiPro>;
  disabled?: boolean;
  /**
   * Whether hidden columns go into the file too.
   *
   * A grid hides columns to stay readable; a document that has to be filed still needs them.
   */
  allColumns?: boolean;
}

export function LogbookExcelExportButton({ apiRef, disabled, allColumns }: Props) {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("logbook.export.tooltip")}>
      <span>
        <Button
          variant="outlined"
          size="small"
          onClick={() => exportGridAsExcel(apiRef, { allColumns })}
          disabled={disabled}
          startIcon={<TableViewIcon />}
          sx={{ whiteSpace: "nowrap" }}
        >
          {t("logbook.export.label")}
        </Button>
      </span>
    </Tooltip>
  );
}
